import { Component, Input } from '@angular/core';
import { ITimestampedAmount } from '../../shared';

@Component({
    selector: 'timestamped-amounts',
    template: require('./timestamped-amounts.component.pug')
})
export class TimestampedAmountsComponent {
    @Input() amounts: ITimestampedAmount[];
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/employees/salaries/timestamped-amounts/timestamped-amounts.component.ts